@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints.scss";

@mixin two-columns {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  > * {
    flex: 1;
    margin-left: 8px;
  }

  > :first-child {
    margin-left: 0;
    margin-right: 8px;
  }
}

.form {
  position: relative;
  margin-right: 5px;
  height: calc(100vh - 50px);
}

.button {
  width: 100%;
}

.buttonContainer {
  margin-top: 20px;
  width: 100%;
  margin-top: 20px;
}

.headerContent {
  font-family: typography.$font-serif;
  color: var(--brand-indigo);
  font-style: normal;
  text-transform: capitalize;
  text-align: center;
  font-weight: 400;
  font-size: 22px;
}

.describedBy {
  text-align: center;
  font-family: typography.$font-mont;
}

.desiredTimeOfDayRow {
  margin-bottom: 20px;
}

.desiredTimeOfDay {
  @include typography.caption-semibold;
  color: var(--blue-01);
  margin-bottom: 13px;
}

.circleRow {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.selectedCircle {
  border: 2px solid var(--blue-01);
  box-shadow: 0 5px 5px rgb(0 0 0 / 25%);
  background-color: var(--blue-03);
}

.unSelectedCircle {
  background-color: var(--gray-04);
  border: 1px solid var(--blue-01-at-30);
}

.circleButton {
  border-radius: 50%;
  min-width: 48px;
  width: 48px;
  height: 48px;
  flex-grow: 0;
  margin-bottom: 10px;
  cursor: pointer;
}

.circleButton:hover {
  background-color: var(--blue-03);
}

.circleButton:active:not(:disabled) {
  box-shadow: none;
}

.desiredTimeOfDayHeading {
  @include typography.caption-semibold;
}

.desiredTimeOfDaySubHeading {
  @include typography.caption;
}

.prompt {
  margin-top: 0;
  // font-family: typography.$font-mont;
}

.emptyError {
  height: 14px;
  min-height: 0;
  padding: 0;

  @include breakpoints.desktop {
    display: none;
  }
}

.desktopTwoColumns {
  @include breakpoints.desktop {
    @include two-columns;
  }
}

.smsHelp {
  @include typography.caption;
  /*margin: 10px 0 24px; */
  color: var(--black-at-75);
  font-size: 12px;

  a {
    color: inherit;
    text-decoration: none;
  }
}

.agreeText {
  color: var(--black-at-75);
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 140%;
  a {
    color: inherit;
    text-decoration: none;
  }
  u {
    text-decoration: none;
  }
  font-family: typography.$font-mont;
}
